export default __webpack_public_path__ + "images/d5ab95aab6f5e5775e46a9917fccaebc-PyxHealthTransparentLogoWithText.png";